import React from 'react';
import { motion } from 'framer-motion';

export default function About() {
  return (
    <div className="min-h-screen" data-testid="about-page">
      <section
        className="relative min-h-[60vh] flex items-center justify-center"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(247, 241, 232, 0.9), rgba(226, 199, 164, 0.9)), url('https://images.unsplash.com/photo-1646774084704-02e47cc55596')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-3xl mx-auto px-6 text-center space-y-6"
        >
          <h1 className="heading-1">About Tiger Wellness Club</h1>
          <p className="body-text text-dark-cedar/80">
            Doctor-curated tea rituals for everyday wellness
          </p>
        </motion.div>
      </section>

      <section className="section-padding bg-soft-ivory">
        <div className="max-w-4xl mx-auto space-y-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h2 className="heading-2">Our Story</h2>
            <p className="body-text text-dark-cedar/80 leading-relaxed">
              Tiger Wellness Club was founded with a vision to create a quiet-luxury wellness experience that blends Eastern medicine wisdom with modern science. Our doctor-curated tea rituals are designed to support your daily wellness journey—whether you're seeking better sleep, enhanced focus, digestive harmony, or inner calm.
            </p>
            <p className="body-text text-dark-cedar/80 leading-relaxed">
              We believe wellness should feel like a ritual, not a routine. Each tea blend is carefully formulated to work with your unique body profile and wellness goals, drawing from traditional body-type principles while honoring the latest research in functional medicine.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h2 className="heading-2">Meet Dr. Soomin</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <img
                  src="https://images.unsplash.com/photo-1729731322165-241913981ba1"
                  alt="Dr. Soomin"
                  className="rounded-lg shadow-lg"
                />
              </div>
              <div className="space-y-4">
                <p className="body-text text-dark-cedar/80 leading-relaxed">
                  Dr. Soomin is an aesthetic and wellness physician specializing in integrative approaches to health. With a background in both Western medicine and Eastern wellness traditions, she designs personalized tea rituals that support the body's natural healing processes.
                </p>
                <p className="body-text text-dark-cedar/80 leading-relaxed">
                  Her philosophy: wellness should be gentle, sustainable, and deeply personal—never extreme or one-size-fits-all.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h2 className="heading-2">Future Vision</h2>
            <p className="body-text text-dark-cedar/80 leading-relaxed">
              Our vision extends beyond tea. We're building a physical wellness sanctuary that combines tea rituals with sauna, pilates, head spa, IV wellness treatments, and aesthetic clinic services—all in a space that feels like a mix of Hermès and your most comfortable home.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}